// A two-click button for actions with money behind them: the first click arms it (label changes, 4 s to
// confirm), the second fires. Replaces confirm(), which the page never calls.

import { useEffect, useState, type ReactNode } from 'react';

export function ArmedButton({ label, armedLabel, onFire, tone, icon }: { label: string; armedLabel: string; onFire: () => void | Promise<void>; tone?: 'danger'; icon?: ReactNode }) {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(t);
  }, [armed]);
  const base = armed
    ? 'bg-red-500/25 text-red-300 ring-1 ring-red-400'
    : tone === 'danger' ? 'bg-red-500/10 text-red-400 hover:bg-red-500/20' : 'bg-muted hover:bg-accent';
  return (
    <button
      type="button"
      className={`flex items-center gap-1 rounded px-2 py-1 font-mono text-xs ${base}`}
      onClick={() => {
        if (!armed) { setArmed(true); return; }
        setArmed(false);
        void onFire();
      }}
    >
      {icon}{armed ? armedLabel : label}
    </button>
  );
}
